import { makeLabels } from 'utils/i18n';

export const KEYS = {
  PAYMENT_METHOD: 'Crypto',
  FALLBACK_FIAT_CURRENCY_CODE: 'USD',
  DATA_PLACEHOLDER: '—',
};

export const MESSAGES_NAMESPACE = 'page.pwcOrders.view.sections.order.receipt';

export const LABELS = makeLabels(
  {
    PAGE_TITLE: ['title', 'Receipt from {{merchantName}}'],
    ORDER_ID: ['orderId', 'Order ID'],
    CUSTOMER_NAME: ['customerName', 'Customer'],
    CUSTOMER_EMAIL: ['customerEmail', 'Customer Email'],
    ORDER_DATE: ['orderDate', 'Order Date'],
    PAYMENT_METHOD: ['paymentMethod', 'Payment Method'],
    AMOUNT_PAID_IN_FIAT: ['amountPaidInFiat', 'Amount Paid in Fiat'],
    AMOUNT_PAID_IN_CRYPTO: ['amountPaidInCrypto', 'Amount Paid in Crypto'],
    NETWORK: ['network', 'Network'],
    SENDING_WALLET: ['sendingWallet', 'Sending Wallet'],
    TRANSACTION_HASH: ['transactionHash', 'Transaction Hash'],
    POWERED_BY: ['poweredBy', 'Powered by'],
    ORDER_SUMMARY: ['orderSummary', 'Order Summary'],
    TOTAL: ['total', 'Total'],
  },
  MESSAGES_NAMESPACE,
);
